module.exports = __webpack_public_path__ + "img/icon-history.284a0357.png";